export enum IngredientType {
  Dropdown,
  Limit,
  ServiceFee,
  Question,
  Tip
}
